export const asyncDelay = (delay = 0) =>
  new Promise(resolve => {
    setTimeout(() => resolve(null), delay)
  })
